import { filter, mergeMap, of, withLatestFrom } from 'rxjs'
import { catchError, retryWhen } from 'rxjs/operators'
import { serverIsNotAvailable } from '../../../../Framework/Epic/ServerNotAvailable.js'
import type { Epic } from '../../../index.js'
import { Actions } from '../../../Slice/index.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'

export const DeleteOrderEpic: Epic = (action$, state$, { order, OrderRepository }) =>
  action$.pipe(
    filter(Actions.order.deleteOrderRequest.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) =>
      OrderRepository.deleteOrder(action.payload, state.authentication.user).pipe(
        mergeMap((response) => of(order.deleteOrderSuccess(response))),
        retryWhen(serverIsNotAvailable()),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(order.deleteOrderFailure({ error }))
          })
        ),
        catchError((error: Error) => {
          console.error('Error deleting order', error)
          return of(order.deleteOrderFailure({ error }))
        })
      )
    )
  )
